import { render, staticRenderFns } from "./textCoverNew.vue?vue&type=template&id=915932ae&"
import script from "./textCoverNew.vue?vue&type=script&lang=ts&"
export * from "./textCoverNew.vue?vue&type=script&lang=ts&"
import style0 from "./textCoverNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports